<app-form-input  
[label]="step2.getobjet" [name]="getUid()+'_SepAtt_objet'"
[parentForm]="parentForm" [rule]="'required|minSize_5'"
[type]="'text'" [disabled]="disabled"
[errorMessage]="{'required' : 'ctr_107', 'minLength' : 'ctr_123'}"
[value]="attribution?.descriptionReduite?.objet">
</app-form-input>

<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attribution.autresInformations?.valeurTotaleEstimee?.valeur"
  [label]="step2.getvaleurtotaleestimee"
  [type]="'number'"
  [rule]="'digits_2'"
  [name]="getUidTypeMontant() + '_SepAtt_valeur'"
>
</app-form-input>
<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attribution.autresInformations?.valeurTotaleEstimee?.devise"
  [label]="step2.getdevise"
  [type]="'autocomplete'"
  [autoCompleteType]="'DEVISE'"
  [autoCompleteTypeIndex]="0"
  [rule]="'pattern_13'"
  [errorMessage]="{}"
  [name]="getUidTypeMontant() + '_SepAtt_devise'"
>
</app-form-input>
<app-form-input
  [parentForm]="parentForm"
  [disabled]="disabled"
  [value]="attribution.autresInformations?.dateAttribution"
  [label]="step2.getdateattribution"
  [rule]="'required'"
  [errorMessage]="{'required' : 'ctr_429'}"
  [type]="'date'"
  [rule]="'pattern_7'"
  [name]="getUidTypeAutresInfosATTR() + '_SepAtt_dateAttribution'"
>
</app-form-input>


  <app-form-input  
  [label]="step2.getprocedure" [name]="getUid()+'_SepAtt_procedure'"
  [parentForm]="parentForm" [rule]="''" 
  [type]="'text'" [disabled]="disabled"
  [value]="attribution?.procedure">
  </app-form-input>

  <span class="d-block">Attribution de l'avis</span>

  <app-form-input
    [label]=""
    [name]="getUidAttribution() + '_SepSep_TypeResultatAttribution_SepAtt_infructueux'"
    [parentForm]="parentForm"
    [disabled]="disabled"
    [type]="'radio'"
    [rule]="'pattern_29|required'"
    [errorMessage]="{ required: 'ctr_300' }"
    [radios]="[
      {
        value: infructueux,
        label: step2.getinfructueux
      },
      {
        value: sansSuite,
        label: step2.getsanssuite
      },
      {
        value: attribueUnique,
        label: step2.getattribueunique
      },
      {
        value: attribueLots,
        label: step2.getattribueparlots
      },
      {
        value: lotsInfructueux,
        label: step2.getlotsinfructueux
      }
    ]"
    [value]="radioButtonValue"
  >
  </app-form-input>

  <span class="d-block">{{ step2.getspan4 | translate }}</span>